import axios from "axios";

export default async function signUpService(username, email, password) {
  axios
    .post("http://localhost:5000/api/v1/user/", { username, email, password })
    .then((res) => console.log(res.data))
    .catch((err) => console.log(err));
}
